module.exports = __webpack_public_path__ + "static/media/kapcsolat-bg-1920.dc173beb.jpg";